import React from "react";
import PropTypes from "prop-types";

Spinner.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string,
};

export default function Spinner({ show = true, className, ...props }) {
  if (!show) {
    return null;
  }

  const classes = ["loader", className].filter(Boolean).join(" ");
  return <div className={classes} {...props} />;
}
